import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createMyStatisticsInsightsApi } from '../';
import { createFakePostResponder } from '../../../test-utils';
export var createMyStatisticsInsightsApiTestkit = function (parent) {
    if (parent === void 0) { parent = 'localhost'; }
    var fakeHttp = createHttpTestKit();
    var api = createMyStatisticsInsightsApi(parent, fakeHttp);
    var base = "".concat(parent, "/analytics/me");
    var handler = {
        whenGetOverview: createFakePostResponder(fakeHttp, "".concat(base, "/overview")),
        whenGetNumberOfRepliesCounts: createFakePostResponder(fakeHttp, "".concat(base, "/numberOfReplies/counts")),
        whenGetNumberOfRepliesHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/numberOfReplies/histogram")),
        whenGetSolvedTicketsCounts: createFakePostResponder(fakeHttp, "".concat(base, "/solvedTickets/counts")),
        whenGetSolvedTicketsHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/solvedTickets/histogram")),
        whenGetCallVolumeCounts: createFakePostResponder(fakeHttp, "".concat(base, "/callVolume/counts")),
        whenGetCallVolumeHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/callVolume/histogram")),
        whenGetHandleTimeCounts: createFakePostResponder(fakeHttp, "".concat(base, "/handleTime/counts")),
        whenGetHandleTimeHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/handleTime/histogram")),
        whenGetAssistedCallsCounts: createFakePostResponder(fakeHttp, "".concat(base, "/assistedCalls/counts")),
        whenGetAssistedCallsHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/assistedCalls/histogram")),
        whenGetNewPublishedArticlesCounts: createFakePostResponder(fakeHttp, "".concat(base, "/newPublishedArticles/counts")),
        whenGetNewPublishedArticlesHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/newPublishedArticles/histogram")),
        whenGetArticleUpdatesCounts: createFakePostResponder(fakeHttp, "".concat(base, "/articleUpdates/counts")),
        whenGetArticleUpdatesHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/articleUpdates/histogram")),
        whenGetServedChatsHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/servedChats/histogram")),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map